import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Row, Col, Container, Form } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import Field from '../../../components/Entity/Field'
import ModalPicker from '../../../components/Modals/ModalPicker'
import { ApiManager } from '../../../core/api-manager';
import { Utils } from '../../../core/utils';



export default function DGSH_customer_ddt({ data, setData, selectedRows, setSelectedRows, refreshData }) {

    const navigate = useNavigate();

    // Movement scope modal state
    const [showMovementScopeModal, setShowMovementScopeModal] = useState(false);
    const [movementScope, setMovementScope] = useState(null);
    const [movementScopeList, setMovementScopeList] = useState(null);
    const [unloadLoading, setUnloadLoading] = useState(false);
    const [arrayError, setArrayError] = useState([]);
    const [unloadResult, setUnloadResult] = useState(null); // null | { success: true } | { success: false }
    const [showErrorModal, setShowErrorModal] = useState(false);

    useEffect(() => {
        // Load movement scopes and default to "VENDITA" if present
        async function initMovementScopes() {
            const sorting = { field: 'id', order: 'asc' };
            const resMov = await DataManager.getItems('movement_scope', 1, 100, sorting);
            if (resMov?.success === 1) {
                setMovementScopeList(resMov.body);
                const vendita = resMov.body.find((item) => item.name === 'VENDITA');
                if (vendita) setMovementScope(vendita.id);
            }
        }
        initMovementScopes();
    }, []);

    function openMovementScopeModal() {
        setShowMovementScopeModal(true);
    }

    function closeMovementScopeModal() {
        setShowMovementScopeModal(false);
    }

    function closeResultModal() {
        setShowErrorModal(false);
        setUnloadResult(null);
        setArrayError([]);
        if (typeof refreshData === 'function') {
            refreshData();
        }
    }


    async function createInvoice() {
        const toastId = toast.loading('Generazione fattura differita...');

        var sorting = {
            'field': 'id',
            'order': 'DESC'
        }
        var constraints = [
            { fieldName: "id", type: "in", value: selectedRows.toString() }
        ]

        var s = await DataManager.searchItems('customer_ddt', 1, 100, sorting, '', [], constraints);
        if (s.success === 1) {
            console.log(s);
            const d = s.body;

            var tempArrayOrder = [];

            for (let i = 0; i < d.length; i++) {
                var sortingCO = {
                    'field': 'id',
                    'order': 'DESC'
                }
                var constraintsCO = [
                    { fieldName: "internalCode", type: "value", value: d[i].orderNumber }
                ]
                var co = await DataManager.searchItemsSimple('customer_order', 1, 100, sortingCO, '', [], constraintsCO);
                if (co.success === 1) {
                    tempArrayOrder.push(co.body[0])
                }
            }



            const agg = tempArrayOrder.every(a => a.idCustomer?.aggregateInvoices === 1);
            const onlyDDT = tempArrayOrder.every(a => a.idPaymentCondition?.unloadDDT === 0);
            const firstAgent = tempArrayOrder[0].idSalesAgent?.id;
            const firstCustomer = tempArrayOrder[0].idCustomer?.id;
            const firstPayment = tempArrayOrder[0].idPaymentCondition?.id;
            const firstAddress = tempArrayOrder[0].address?.id;
            const firstVatCondition = tempArrayOrder[0].idVatCondition?.id;
            const sameAgent = tempArrayOrder.every(a => a.idSalesAgent?.id === firstAgent);
            const sameCustomer = tempArrayOrder.every(a => a.idCustomer?.id === firstCustomer);
            const samePayment = tempArrayOrder.every(a => a.idPaymentCondition?.id === firstPayment);
            const sameAddress = tempArrayOrder.every(a => a.address?.id === firstAddress);
            const sameVatCondition = tempArrayOrder.every(a => a.idVatCondition?.id === firstVatCondition);
            console.log(sameAddress, sameAgent, sameCustomer, samePayment, sameVatCondition)
            if (agg) {
                if (!onlyDDT) {
                    toast.update(toastId, { render: 'I DDT devono avere DDT solo cartaceo a NO.', type: 'error', isLoading: false, autoClose: 3000 });
                    return;
                }
                console.log(sameAddress, sameAgent, sameCustomer, samePayment, sameVatCondition)
                if (sameAddress && sameAgent && sameCustomer && samePayment && sameVatCondition) {
                    const IC = s.body[0].internalCode

                    const totalRows = [];
                    const idRows = [];


                    d.forEach(item => {
                        item.rows.forEach(element => {
                            idRows.push(element.idCustomerOrderRow);
                        });
                    });


                    var sortingRows = {
                        'field': 'id',
                        'order': 'DESC'
                    }
                    var constraintsRows = [
                        { fieldName: "id", type: "in", value: idRows.toString() }
                    ]

                    var resRows = await DataManager.searchItems('customer_order_rows', 1, 100, sortingRows, '', [], constraintsRows);

                    // Build totalRows with idIvaItemModel from customer_order_rows
                    d.forEach(item => {
                        item.rows.forEach(element => {
                            // Find the corresponding customer_order_row to get idVatCondition
                            const orderRow = resRows.body.find(r => r.id === element.idCustomerOrderRow);
                            const element1 = {
                                ...element,
                                riferimentoDDT: IC,
                                idIvaItemModel: orderRow?.idVatCondition?.id || null
                            };
                            totalRows.push(element1);
                        });
                    });

                    var sortingCo = {
                        'field': 'id',
                        'order': 'DESC'
                    }
                    var constraintsCo = [
                        { fieldName: "id", type: "value", value: resRows.body[0].idCustomerOrder }
                    ]

                    var resCO = await DataManager.searchItems('customer_order', 1, 100, sortingCo, '', [], constraintsCo);


                    var totalImballo = resRows.body.filter(e => e.idItemModel.type.value === '60_CASSA_DI_LEGNO').reduce((acc, e) => acc + parseFloat(e.total), 0);

                    // Calculate row totals
                    var totaleImponibileRighe = resRows.body.reduce((acc, cur) => acc + parseFloat(cur.totalRow), 0);
                    var totaleIvaRighe = resRows.body.reduce((acc, cur) => acc + parseFloat(cur.totalIva), 0);

                    // Add shipping and bank costs from customer order
                    var costSpedizione = parseFloat(resCO.body[0].costSpedizione) || 0;
                    var totalSpedizione = parseFloat(resCO.body[0].totalSpedizione) || 0;
                    var costIncasso = parseFloat(resCO.body[0].totalIncasso) || 0;
                    var totalIncassoIva = parseFloat(resCO.body[0].totalIncassoIva) || 0;

                    var ivaSpedizione = totalSpedizione - costSpedizione;
                    var ivaIncasso = totalIncassoIva - costIncasso;

                    var totaleImponibile = totaleImponibileRighe + costSpedizione + costIncasso;
                    var totaleIva = totaleIvaRighe + ivaSpedizione + ivaIncasso;
                    var totale = totaleImponibile + totaleIva;

                    var data1 = {
                        orderNumber: d[0].rows[0].riferimentoCustomerOrder,
                        documentType: { value: 1 },
                        idCustomer: d[0].idCustomer,
                        nameCustomer: d[0].nameCustomer,
                        addressCustomer: d[0].addressCustomer,
                        idAgent: resCO.body[0].idSalesAgent ? resCO.body[0].idSalesAgent.id : "",
                        phoneCustomer: d[0].phoneCustomer,
                        vatNumberCustomer: d[0].vatNumberCustomer,
                        incotermsCustomer: d[0].incotermsCustomer,
                        paymentConditionCustomer: d[0].paymentConditionCustomer,
                        idPaymentCondition: resCO.body[0].idPaymentCondition ? resCO.body[0].idPaymentCondition.id : "",
                        bankCustomer: d[0].bankCustomer,
                        abi: d[0].abi,
                        cab: d[0].cab,
                        iban: d[0].iban,
                        idCustomerOffice: d[0].idCustomerOffice,
                        addressCustomerOffice: d[0].addressCustomerOffice,
                        phoneCustomerOffice: d[0].phoneCustomerOffice,
                        externalCode: d[0].externalCode,
                        transportReason: d[0].transportReason,
                        idShippingPlan: d[0].idShippingPlan,
                        nameForwarder: d[0].nameForwarder,
                        packagesQuantity: d[0].packagesQuantity,
                        weight: d[0].weight,
                        volume: d[0].volume,
                        itemsAspect: d[0].itemsAspect,
                        transportBy: { value: d[0].transportBy.value },
                        notes: d[0].notes,
                        rows: totalRows,
                        status: { value: '10_CONFIRMED' },
                        totalImponibile: parseFloat(totaleImponibile).toFixed(2),
                        totalIva: parseFloat(totaleIva).toFixed(2),
                        totalPrice: parseFloat(totale).toFixed(2),
                        totalImballo: parseFloat(totalImballo).toFixed(2),
                        idIvaOrdine: resCO.body[0].idVatCondition?.id || null,
                        idIvaSped: resCO.body[0].idVatCondition?.id || null
                    }
                    var i = await DataManager.insertItem('customer_invoices', data1);
                    if (i.success === 1) {
                        for (let i = 0; i < selectedRows.length; i++) {
                            var d1 = {
                                status: { value: '0_PENDING' }
                            }
                            var u = await DataManager.updateItem('customer_ddt', d1, selectedRows[i]);
                            if (u.success === 1) {
                                toast.success('DDT aggiornato con successo!', { theme: 'colored' });

                            } else {
                                toast.error('Errore nel aggiornare il DDT!', { theme: 'colored' });
                            }
                        }
                        toast.update(toastId, { render: 'Fattura differita creata con successo!', type: 'success', isLoading: false, autoClose: 2000 });
                        refreshData();

                    }
                    else {
                        toast.update(toastId, { render: 'Errore nella creazione della fattura!', type: 'error', isLoading: false, autoClose: 3000 });
                    }


                } else {
                    toast.update(toastId, { render: "I documenti devono avere lo stesso CLIENTE, INDIRIZZO DI CONSEGNA, AGENTE, MODALITA' DI PAGAMENTO e CONDIZIONE IVA", type: 'error', isLoading: false, autoClose: 4000 })
                    return;
                }

            } else {
                toast.update(toastId, { render: "Seleziona solo clienti dove l'opzione 'Documenti aggregati' è SI", type: 'error', isLoading: false, autoClose: 4000 })
                return;
            }



        } else {
            toast.update(toastId, { render: 'Errore nel recupero dei DDT selezionati', type: 'error', isLoading: false, autoClose: 3000 });
        }

    }



    // Funzione helper per verificare giacenza e scaricare i figli di un articolo picking
    async function unloadPickingChildren(idItemModel, parentCode, quantity, idWarehouse, checkQuantity, numberDocument) {
        // Recupero la distinta base (MPM) del padre
        const sorting = { field: 'id', order: 'desc' };
        const constraints = [
            { fieldName: 'idItemModel', type: 'value', value: idItemModel }
        ];
        const resMpm = await DataManager.searchItemsSimple('manufacturing_process_model', 1, 1000, sorting, '', [], constraints);

        if (resMpm.success !== 1 || !resMpm.body || resMpm.body.length === 0) {
            return { success: 0, message: 'Distinta base non trovata per articolo picking' };
        }

        const children = resMpm.body;

        // FASE 1: Verifico la giacenza di tutti i figli PRIMA di scaricare
        const insufficientStock = [];
        for (const child of children) {
            const childItemModel = child.idItemModelChild;
            if (!childItemModel) continue;

            const childQty = parseInt(child.quantity || 1) * parseInt(quantity);

            // Recupero la giacenza del figlio nel magazzino specificato
            const stockConstraints = [
                { fieldName: 'idItemModel', type: 'value', value: childItemModel.id },
                { fieldName: 'idWarehouse', type: 'value', value: idWarehouse }
            ];
            const resStock = await DataManager.searchItemsSimple('item_model_stock', 1, 1, sorting, '', [], stockConstraints);

            const availableQty = resStock.success === 1 && resStock.body && resStock.body.length > 0
                ? parseFloat(resStock.body[0].quantity || 0)
                : 0;

            if (availableQty < childQty) {
                insufficientStock.push({
                    parentCode: parentCode,
                    childCode: childItemModel.code,
                    childName: childItemModel.name,
                    requiredQty: childQty,
                    availableQty: availableQty
                });
            }
        }

        // Se qualche figlio non ha giacenza sufficiente, ritorno errore
        if (insufficientStock.length > 0) {
            const errorDetails = insufficientStock.map(item =>
                `${item.childCode} (padre: ${item.parentCode}) - richiesta: ${item.requiredQty}, disponibile: ${item.availableQty}`
            ).join('; ');
            return {
                success: 0,
                message: `Giacenza insufficiente per: ${errorDetails}`,
                insufficientStock
            };
        }

        // FASE 2: Tutti i figli hanno giacenza sufficiente, procedo con lo scarico
        for (const child of children) {
            const childItemModel = child.idItemModelChild;
            if (!childItemModel) continue;

            const childQty = parseInt(child.quantity || 1) * parseInt(quantity);

            const dataUnload = {
                idItem: childItemModel.id,
                idMovementScope: parseInt(movementScope),
                quantity: childQty,
                idWarehouse: idWarehouse,
                numberDocument: numberDocument,
                notes: '',
                checkQuantity: checkQuantity
            };

            const resUnload = await ApiManager.sendAuthenticatedRequest('/custom/warehouse_unload', dataUnload);
            if (resUnload.success !== 1) {
                return {
                    success: 0,
                    message: `Errore nello scarico del figlio ${childItemModel.code}: ${resUnload.message}`
                };
            }
        }

        return { success: 1 };
    }

    async function unloadAll() {
        var sorting = {
            'field': 'id',
            'order': 'DESC'
        }
        var constraints = [
            { fieldName: "id", type: "in", value: selectedRows.toString() }
        ]

        // Ensure movementScope is selected before proceeding
        if (movementScope === null) {
            openMovementScopeModal();
            return;
        }
        setUnloadLoading(true);
        try {
            const errors = [];
            setArrayError([]);
            var s = await DataManager.searchItems('customer_ddt', 1, 100, sorting, '', [], constraints);
            if (s.success === 1) {
                const checkStatus = s.body.every(item => item.status?.value === "0_PENDING");
                console.log(checkStatus, s.body)
                if (checkStatus) {
                    for (let i = 0; i < s.body.length; i++) {
                        let ddtHasErrors = false;
                        var sortingCO = {
                            'field': 'id',
                            'order': 'DESC'
                        }
                        var constraintsCO = [
                            { fieldName: "internalCode", type: "in", value: s.body[i].orderNumber }
                        ]
                        var resCO = await DataManager.searchItemsSimple('customer_order', 1, 100, sortingCO, '', [], constraintsCO)
                        if (resCO.success === 1) {
                            if (resCO.body[0].idWarehouseOutlet?.no_mrp === 0 && resCO.body[0].idWarehouseOutlet?.internal === 1) {
                                //SCARICO DA CENTRALE
                                for (let a = 0; a < s.body[i].rows.length; a++) {
                                    var qta = parseInt(s.body[i].rows[a].quantity)
                                    if (qta !== 0) {
                                        var resItemModel = await DataManager.getItemSimple('item_model', s.body[i].rows[a].idItemModel);
                                        const im = resItemModel.body[0];

                                        // Controllo se l'articolo è di picking
                                        const isPicking = im.picking === 1;
                                        let resUnload;

                                        if (isPicking) {
                                            // Articolo picking: verifico giacenza e scarico i figli dalla distinta (dal magazzino dell'ordine)
                                            resUnload = await unloadPickingChildren(
                                                im.id,
                                                im.code,
                                                parseInt(qta),
                                                resCO.body[0].idWarehouseOutlet?.id,
                                                true,
                                                s.body[i].internalCode
                                            );
                                        } else {
                                            //scarico da magazzino dell'ordine
                                            const dataUnload = {
                                                idItem: im.id,
                                                idMovementScope: parseInt(movementScope),
                                                quantity: parseInt(qta),
                                                idWarehouse: resCO.body[0].idWarehouseOutlet?.id,
                                                numberDocument: s.body[i].internalCode,
                                                notes: '',
                                                checkQuantity: true
                                            }
                                            resUnload = await ApiManager.sendAuthenticatedRequest('/custom/warehouse_unload', dataUnload);
                                        }

                                        if (resUnload.success === 1) {
                                            toast.success('Quantità scaricata con successo', { theme: 'colored' });
                                            var status = { value: '10_UNLOADED' }
                                            const dataUpdate = {
                                                warehouseItemModel: im.idWarehouse ? im.idWarehouse.name : "",
                                                status: status,
                                                fulfilledQuantity: parseInt(qta),
                                                quantityUnloaded: parseInt(qta)
                                            }
                                            var resUpdate = await DataManager.updateItem('customer_ddt_rows', dataUpdate, s.body[i].rows[a].id);
                                            if (resUpdate.success === 1) {
                                                toast.success('Riga aggiornata con successo', { theme: 'colored' });
                                            } else {
                                                toast.error("Errore nell'aggiornare la riga", { theme: 'colored' });
                                                ddtHasErrors = true;
                                                errors.push({ id: im.id, message: "Errore nell'aggiornare la riga", code: im.code, name: im.name })
                                            }
                                        }
                                        else {
                                            ddtHasErrors = true;
                                            errors.push({ id: im.id, message: resUnload.message, code: im.code, name: im.name })
                                        }
                                    }
                                }
                            } else {
                                //SCARICO DA ALTRI --> senza controllo quantity
                                for (let a = 0; a < s.body[i].rows.length; a++) {
                                    var qta = parseInt(s.body[i].rows[a].quantity)
                                    if (qta !== 0) {
                                        var resItemModel = await DataManager.getItemSimple('item_model', s.body[i].rows[a].idItemModel);
                                        const im = resItemModel.body[0];

                                        // Controllo se l'articolo è di picking
                                        const isPicking = im.picking === 1;
                                        let resUnload;

                                        if (isPicking) {
                                            // Articolo picking: verifico giacenza e scarico i figli dalla distinta (dal magazzino dell'ordine)
                                            resUnload = await unloadPickingChildren(
                                                im.id,
                                                im.code,
                                                parseInt(qta),
                                                resCO.body[0].idWarehouseOutlet?.id,
                                                false,
                                                s.body[i].internalCode
                                            );
                                        } else {
                                            //scarico da magazzino di default
                                            const dataUnload = {
                                                idItem: im.id,
                                                idMovementScope: parseInt(movementScope),
                                                quantity: parseInt(qta),
                                                idWarehouse: resCO.body[0].idWarehouseOutlet?.id,
                                                numberDocument: s.body[i].internalCode,
                                                notes: '',
                                                checkQuantity: false
                                            }
                                            resUnload = await ApiManager.sendAuthenticatedRequest('/custom/warehouse_unload', dataUnload);
                                        }

                                        if (resUnload.success === 1) {
                                            toast.success('Quantità scaricata con successo', { theme: 'colored' });
                                            var status = { value: '10_UNLOADED' }
                                            const dataUpdate = {
                                                warehouseItemModel: resCO.body[0].idWarehouseOutlet?.name,
                                                status: status,
                                                fulfilledQuantity: parseInt(qta),
                                                quantityUnloaded: parseInt(qta)
                                            }
                                            var resUpdate = await DataManager.updateItem('customer_ddt_rows', dataUpdate, s.body[i].rows[a].id);
                                            if (resUpdate.success === 1) {
                                                toast.success('Riga aggiornata con successo', { theme: 'colored' });
                                            } else {
                                                toast.error("Errore nell'aggiornare la riga", { theme: 'colored' });
                                                ddtHasErrors = true;
                                                errors.push({ id: im.id, message: "Errore nell'aggiornare la riga", code: im.code, name: im.name })
                                            }
                                        }
                                        else {
                                            ddtHasErrors = true;
                                            errors.push({ id: im.id, message: resUnload.message, code: im.code, name: im.name })
                                        }
                                    }
                                }
                            }
                        } else {
                            ddtHasErrors = true;
                            errors.push({ id: s.body[i].id, message: 'Ordine cliente non trovato', code: s.body[i].orderNumber, name: 'DDT ' + s.body[i].internalCode })
                        }

                        // Se nessun errore per questo DDT, aggiorna stato a 20_UNLOADED
                        if (!ddtHasErrors) {
                            const updateDdtData = { status: { value: '20_UNLOADED' } };
                            const upd = await DataManager.updateItem('customer_ddt', updateDdtData, s.body[i].id);
                            if (upd.success !== 1) {
                                ddtHasErrors = true;
                                errors.push({ id: s.body[i].id, message: 'Impossibile aggiornare lo stato del DDT', code: s.body[i].internalCode, name: 'DDT' })
                            }
                        }
                    }
                    if (errors.length > 0) {
                        setArrayError(errors);
                        setUnloadResult({ success: false });
                        setShowErrorModal(true);
                    } else {
                        setArrayError([]);
                        setUnloadResult({ success: true });
                        setShowErrorModal(true);
                    }
                } else {
                    toast.error("Selezionare solo DDT con stato uguale a IN ATTESA.", { theme: 'colored' })
                }


            }
        } finally {
            setUnloadLoading(false);
        }
    }






    return (
        <>
            <Container>
                <Row>
                    <Button className='my-1' variant='primary' size='sm' onClick={() => createInvoice()}>Crea Fattura differita</Button>
                    <Button className='my-1' variant='success' size='sm' disabled={unloadLoading} onClick={() => openMovementScopeModal()}>
                        {unloadLoading ? (<><Spinner animation='border' size='sm' className='me-2' />Scarico in corso...</>) : 'Scarica tutto'}
                    </Button>
                </Row>
                {null}
            </Container>

            {/* Modal: Esito scarico */}
            <Modal show={showErrorModal} onHide={closeResultModal} centered size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>{arrayError && arrayError.length > 0 ? 'Errori durante lo scarico' : 'Scarico completato'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {arrayError && arrayError.length > 0 ? (
                        <Table striped bordered hover size='sm' className='mb-0'>
                            <thead>
                                <tr>
                                    <th style={{ width: '15%' }}>Codice</th>
                                    <th style={{ width: '35%' }}>Nome</th>
                                    <th>Messaggio</th>
                                </tr>
                            </thead>
                            <tbody>
                                {arrayError.map((e) => (
                                    <tr key={e.id}>
                                        <td>{e.code}</td>
                                        <td>{e.name}</td>
                                        <td>{e.message}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <Alert variant='success' className='mb-0'>Scarico completato con successo.</Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='primary' onClick={closeResultModal}>Chiudi</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal: Select Movement Scope before unloading */}
            <Modal show={showMovementScopeModal} onHide={closeMovementScopeModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Seleziona causale movimentazione</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {movementScopeList && movementScopeList.length > 0 ? (
                        <Form>
                            <Form.Label>Causale</Form.Label>
                            <Form.Select onChange={(e) => setMovementScope(e.target.value)} value={movementScope || ''}>
                                <option value='' disabled>Seleziona una causale</option>
                                {movementScopeList.map((item) => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                            </Form.Select>
                        </Form>
                    ) : (
                        <Alert variant='info' className='mb-0'>Caricamento causali movimentazione...</Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={closeMovementScopeModal} disabled={unloadLoading}>Annulla</Button>
                    <Button
                        variant='primary'
                        disabled={movementScope === null || unloadLoading}
                        onClick={async () => {
                            if (movementScope === null) return;
                            closeMovementScopeModal();
                            await unloadAll();
                        }}
                    >
                        {unloadLoading ? (<><Spinner animation='border' size='sm' className='me-2' />In corso...</>) : 'Conferma e scarica'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};
